var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoins = function SvgCoins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#coins_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.429 12.857c4.26 0 7.714-1.534 7.714-3.428C23.143 7.534 19.689 6 15.428 6S7.714 7.534 7.714 9.429s3.454 3.428 7.714 3.428"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.714 9.429v10.285c0 1.886 3.429 3.429 7.714 3.429s7.715-1.543 7.715-3.429V9.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.143 14.571c0 1.886-3.429 3.429-7.715 3.429s-7.714-1.543-7.714-3.429M15.257 2.587A11.6 11.6 0 0 0 8.571.872C4.303.872.857 2.415.857 4.301c0 1.011.994 1.92 2.572 2.571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.429 17.158C1.85 16.507.857 15.598.857 14.587V4.301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.429 12.015C1.85 11.364.857 10.455.857 9.444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "coins_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCoins;